import Navbar from './Components/Navbar.jsx';
import Hero from './Components/Hero.jsx';
import About from './Components/About.jsx';
import Skills from './Components/Skills.jsx';
import Projects from './Components/Projects.jsx';
import Contact from './Components/Contact.jsx';
function App(){
 return (
    <div>
        <Navbar />
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Contact />

    </div>
 )
}
export default App;